export default function ConfirmedVector() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
			<path stroke="#fff" d="m12 4-7.3 7.3L1.3 8M14.7 6.7l-5 5-1-1" />
		</svg>
	);
}
